import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function SupportIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M2.381 5.302c-.25.077-.381.319-.381.642v2.54c0 .374.05.642.381.642h.844a4.7 4.7 0 0 1 .06-2.77 4.84 4.84 0 0 1 1.613-2.283 5.1 5.1 0 0 1 5.436-.521 4.9 4.9 0 0 1 2.042 1.933 4.73 4.73 0 0 1-.397 5.294 4.97 4.97 0 0 1-2.308 1.626s-.65-.695-.982-.695h-1.96c-.332 0-.664.168-.664.645 0 .476.332.645.664.645h1.96c.332 0 .664-.322.982-.551m.014-9.126c-.106.615-.664 1.13-1.37 1.24m4.69 4.566c.663 0 .995 0 .995-.645V5.62c0-.322-.332-.323-.332-.323M5.07 6.488c.332-.322 1.96-.322 2.292 0m1.66 0c.332-.322 1.959-.322 2.291 0M9.32 8.827c-.332.322-1.96.322-2.291 0" /></svg>
  );
}

export default SupportIcon;
